import { HEATMAP_MARGIN } from './constants';
import { sampleField } from './fieldRaster';

export interface HeatmapHover {
  date: string;
  price: number;
  value: number;
}

/** Value under the cursor, or null when the pointer is outside the plot. */
export function hoverCell(
  offsetX: number,
  offsetY: number,
  width: number,
  height: number,
  strikes: number[],
  dates: string[],
  field: number[][]
): HeatmapHover | null {
  const nDates = dates.length;
  const nK = strikes.length;
  if (nDates === 0 || nK < 2) return null;
  const m = HEATMAP_MARGIN;
  const iw = width - m.left - m.right;
  const ih = height - m.top - m.bottom;
  if (iw < 40 || ih < 40) return null;
  const x = offsetX - m.left;
  const y = offsetY - m.top;
  if (x < 0 || y < 0 || x > iw || y > ih) return null;
  const datePos = (x / iw) * Math.max(nDates - 1, 0);
  const k0 = strikes[0]!;
  const kN = strikes[nK - 1]!;
  const price = kN + (y / ih) * (k0 - kN);
  const di = Math.round(Math.min(nDates - 1, Math.max(0, datePos)));
  const date = dates[di];
  if (!date) return null;
  return {
    date,
    price,
    value: sampleField(strikes, field, price, datePos),
  };
}
